import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import type { CopilotLang } from './copilot-translations';
import { copilotTranslations, getBestContextKey } from './copilot-translations';

/** Quick-action navigation targets */
export const QUICK_ACTIONS = [
  { key: 'dashboard',     path: '/dashboard',                           icon: '🏠' },
  { key: 'createCompany', path: '/dashboard/companies/creer-entreprise', icon: '🏛️' },
  { key: 'documents',     path: '/dashboard/companies/documents',        icon: '📂' },
  { key: 'finance',       path: '/dashboard/finance',                   icon: '💰' },
  { key: 'genvest',       path: '/dashboard/genvest',                   icon: '📈' },
  { key: 'settings',      path: '/dashboard/settings',                  icon: '⚙️' },
] as const;

export type QuickActionKey = typeof QUICK_ACTIONS[number]['key'];

/** Returns context-aware information about current page */
export function useCopilotContext(lang: CopilotLang) {
  const location  = useLocation();
  const navigate  = useNavigate();
  const strings   = copilotTranslations[lang];

  const contextKey    = useMemo(() => getBestContextKey(location.pathname, lang), [location.pathname, lang]);
  const contextAnswer = useMemo(() => strings.contextResponses[contextKey] ?? strings.contextResponses['default'], [strings, contextKey]);

  const navigateTo = (path: string) => navigate(path);

  return { pathname: location.pathname, contextAnswer, strings, navigateTo };
}
